import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Use for <a href>: host-only values (e.g. www.example.com) are otherwise resolved as same-origin paths. */
export function ensureHttpUrl(url: string): string {
  const t = url.trim()
  if (!t) return t
  if (/^https?:\/\//i.test(t)) return t
  if (t.startsWith('//')) return t
  return `https://${t}`
}
